export const Colors = {
  battleshipGrey: '#727585',
  silver: '#dddee2',
  almostBlack: '#2b2c3d',
  almostWhite: '#f5f5f6',
  orange: '#f59b24',
  darkOrange: '#eb730b',
  almostRed: '#e14d62',
  paleOrange: '#ffd68f',
  greenish: '#07a87e',
  darkPerriwinkle: '#6473dc',
  yellowSnow: '#fff2da',
  white: '#ffffff',
  palePerriwinkle: '#d4d8f5',

  facebookBlue: '#4267b2',
};
